export enum Stage {
    Dev = 'dev',
    Beta = 'beta',
    Staging = 'staging',
    Live = 'live'
}

export enum Client {
    AOL = 'AOL',
    ADE = 'ADE',
    TUK = 'TUK',
    NXT = 'NXT',
    BTS = 'BTS'
}